import { createAction } from "@reduxjs/toolkit";

import {
  clearCreatorStreamsType,
  getCreatorStreamsActionTypes,
  updateCreatorStreamReminderType,
} from "./actionTypes";

export const getCreatorStreams = createAction(
  getCreatorStreamsActionTypes.request,
  (payload) => ({ payload }),
);

export const getCreatorStreamsSuccess = createAction(
  getCreatorStreamsActionTypes.success,
  (payload) => ({ payload }),
);

export const getCreatorStreamsFailure = createAction(
  getCreatorStreamsActionTypes.failure,
  (payload) => ({ payload }),
);

export const updateCreatorStreamReminder = createAction(
  updateCreatorStreamReminderType,
  (payload) => ({ payload }),
);

export const clearCreatorStreams = createAction(
  clearCreatorStreamsType,
  (payload) => ({ payload }),
);
